import axios from '../axiosInstances/axiosInstance';

export const changePassword = (passwords) => {
  return axios.put(`/users/password`, passwords);
};
